export default "__VITE_ASSET__1fAXCB2H__"